'use client';

import { useMemo, type ReactNode } from 'react';
import { EntityResolverProvider } from './EntityResolverContext';
import {
  buildResolvedCredentialsMap,
  type CredentialEntitySource,
} from './credential-entities.utils';

type CredentialEntityResolverProps = {
  credentials: CredentialEntitySource[];
  children: ReactNode;
};

export function CredentialEntityResolver({
  credentials,
  children,
}: CredentialEntityResolverProps) {
  const resolvedCredentials = useMemo(
    () => buildResolvedCredentialsMap(credentials),
    [credentials],
  );

  return (
    <EntityResolverProvider entities={{ credentials: resolvedCredentials }}>
      {children}
    </EntityResolverProvider>
  );
}
